import React, { Component } from 'react';

import Layout from '../components/Layout';
import Classes from './404.module.css';
import Sidebar from '../components/Sidebar';
import Menubar from '../components/Menubar';
import CardList from '../components/blogs/BlogsList/BlogsList';
import SearchStyle from '../components/blogs/SearchBox/SearchBox.module.css';
import SearchBox from '../components/blogs/SearchBox/SearchBox';
class Publications extends Component {
  state = {
    cardList: [
      {
        id: 'All Publications - Amazon Books',
        title: 'All Publications - Amazon Books',
        link:
          'https://www.amazon.com/s?i=digital-text&rh=p_27%3AI+Love+Allah&s=relevancerank&text=I+Love+Allah&ref=dp_byline_sr_ebooks_1',
        image: 'https://iloveallah.net/static/ILoveAllah.png',
      },
      {
        id:
          'Practice steps to happiness from Madarij al Salikeen by Ibn al Qayim: Madarij al Salikeen by Ibn al Qayim - Amazon Book',
        title:
          'Practice steps to happiness from Madarij al Salikeen by Ibn al Qayim: Madarij al Salikeen by Ibn al Qayim - Amazon Book',
        link: 'https://www.amazon.com/dp/B08KP6QQV3',
        image: 'https://iloveallah.net/static/amazonmadarij.png',
      },
      {
        id: 'Duaa and Supplications to Allah - Amazon Book',
        title: 'Duaa and Supplications to Allah - Amazon Book',
        link: 'https://www.amazon.com/dp/B08BWJZV3V',
        image: 'https://iloveallah.net/static/amazonduaa.png',
      },
      {
        id: 'Ramadan Is the best medication for our hearts - Amazon Book',
        title:
          'Lets Purify Our Hearts: Ramadan Is the best medication for our hearts  - Kindle Edition - Amazon Book',
        link:
          'https://www.amazon.com/dp/B08BXFQJLX/ref=sr_1_1?dchild=1&qid=1593287405&refinements=p_27%3AI+Love+Allah&s=digital-text&sr=1-1&text=I+Love+Allah',
        image: 'https://iloveallah.net/static/amazonramadan.png',
      },
      {
        id:
          'Monologue with Allah(free style duaa). : مناجاة الله (Practical Steps to Happiness) - Amazon Book',
        title:
          'Monologue with Allah(free style duaa). : مناجاة الله (Practical Steps to Happiness)  - Kindle Edition - Amazon Book',
        link: 'https://www.amazon.com/dp/B08CCKWPCH',
        image: 'https://iloveallah.net/static/amazon_monologue.png',
      },
    ],
    searchTerm: '',
  };
  render() {
    const { cardList, searchTerm } = this.state;
    const filteredList = cardList.filter(card =>
      card.title.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    return (
      <Layout>
        <Sidebar showTabs="false" />
        <SearchBox
          placeHolder="Search for a book by title"
          changeHandler={e =>
            this.setState({
              searchTerm: e.target.value,
            })
          }
        />
        <CardList list={filteredList} />
      </Layout>
    );
  }
}

export default Publications;
